import React from 'react'
import UnifiedButton from '../../shared/Button'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom';

function LegalFormsFirstSection() {


    const navigate = useNavigate()


    const handleplaylistformClick = () => {
        console.log('Navigating to /pricing');
        navigate('/pricing');
        window.scrollTo(0, 0);
    };

    return (
        <section className="about-section">
            <div className="about-content">
                <Typography variant='h4'>Legal Forms</Typography>
                <Typography>Explore the history of FM Digital Official and the inspiration behind its founding.</Typography>
                <UnifiedButton onClick={handleplaylistformClick} variant="contained" className="cta-button" textContent={'Join Us here'} />

            </div>
        </section>
    )
}

export default LegalFormsFirstSection
